import React, { useState, useEffect } from 'react'
import '../../styles/main.css'
import { Link } from 'react-router-dom'
import heroImg from '../../assets/img/map.png'
import googleStore from '../../assets/img/Google_Store.png'
import appStore from '../../assets/img/Store.png'
import Icon1 from '../../assets/img/icon/demand.png'
import Icon2 from '../../assets/img/icon/rescue-safety-ring.png'
import Icon3 from '../../assets/img/icon/arrow-9.png'
import Icon4 from '../../assets/img/icon/globe.png'
import Icon5 from '../../assets/img/icon/coin-morph.png'
import Icon6 from '../../assets/img/icon/savings-pig.png'
import ghanaFlag from '../../assets/img/flag/ghana_flag.png'   
import senegalFlag from '../../assets/img/flag/senegal_flag.png'
import nigeriaFlag from '../../assets/img/flag/nigeria_flag.png'
import kenyaFlag from '../../assets/img/flag/kenya_flag.png'
import egyptFlag from '../../assets/img/flag/egypt_flag.png'
import malawiFlag from '../../assets/img/flag/malawi_flag.png'
import rwandaFlag from '../../assets/img/flag/rwanda_flag.png'
import southAfricaFlag from '../../assets/img/flag/south-africa_flag.png'
import authorImg from '../../assets/img/image1.jpg'
import image1 from '../../assets/img/find.jpeg'
import image2 from '../../assets/img/image1.jpeg'
import image3 from '../../assets/img/send-money.jpg'
import { ArrowLeft, ArrowRight } from 'iconsax-react'
import empowerImg from '../../assets/img/empower.png'
import image4 from '../../assets/img/image2.jpg'
import line from '../../assets/img/line.png'
import blog1 from '../../assets/img/blog/blog1.jpeg'
import blog2 from '../../assets/img/blog/blog2.jpeg'
import blog3 from '../../assets/img/blog/blog3.jpeg'
import blog4 from '../../assets/img/blog/blog4.jpeg'
import Slider from "react-slick";
import partner1 from '../../assets/img/client-1.png'
import partner2 from '../../assets/img/client-2.png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet-async";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import descriptionVideo from '../../assets/videos/description_video.mp4';
import CurrencyConverter from '../../components/CurrencyConversion/CurrencyConverter';
import TrustpilotWidget from '../../components/Trustpilot/TrustpilotWidget';




// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

function Home() {

  const flags = {
    NGN: nigeriaFlag,
    GHS: ghanaFlag,
    SEN: senegalFlag,
    KEN: kenyaFlag,
    EGY: egyptFlag,
    MAL: malawiFlag,
    RWA: rwandaFlag,
    SAF: southAfricaFlag,
  };

  const exchangeRates = {
    NGN: 1,
    GHS: 0.1,
    SEN: 0.2,
    KEN: 0.3,
    EGY: 0.4,
    MAL: 0.5,
    RWA: 0.6,
    SAF: 0.7,
  };

  const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;

  const [sendAmount, setSendAmount] = useState(30000);
  const [sendCurrency, setSendCurrency] = useState('NGN');
  const [receiveCurrency, setReceiveCurrency] = useState('GHS');
  const [receiveAmount, setReceiveAmount] = useState(0);
  const [posts, setPosts] = useState([]);

  // Exchange rate (in real app, this would come from an API)
  const exchangeRate = 0.1; // NGN 1 = GHS 0.1
  const fee = 1600.32;

  useEffect(() => {
    const converted = sendAmount * exchangeRates[receiveCurrency];
    setReceiveAmount(converted.toFixed(2));
  }, [sendAmount, receiveCurrency]);

  const partners = {
    dots: false,
    arrows: false,
    nav: false,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const testimonials = [
    {
      flag: senegalFlag,
      content: "Sending money home used to be stressful and expensive. With Cardplot, I can transfer funds instantly, no hidden fees, no hassle!",
      author: "Kofi D.",
      position: "Freelancer, Ghana",
      image: authorImg
    },
    {
      flag: ghanaFlag,
      content: "The real-time currency conversion feature has made international transactions so much easier for my business.",
      author: "Amara B.",
      position: "Business Owner, Senegal",
      image: authorImg
    },
    {
      flag: senegalFlag,
      content: "I appreciate how secure and reliable the platform is. It's transformed how I handle cross-border payments.",
      author: "Emmanuel K.",
      position: "Developer, Ghana",
      image: authorImg
    },
    {
      flag: ghanaFlag,
      content: "I've been using Cardplot to manage my finances for the past five years. It's helped me save money and make more informed decisions.",
      author: "Maryam A.",
      position: "Financial Advisor, Ghana",
      image: authorImg
    }
  ]

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch('https://blog.cardplot.com/wp-json/wp/v2/posts');
        const data = await response.json();
        setPosts(data);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };

    fetchPosts();
  }, []);
  
  const decodeHTML = (htmlString) => {
    if (!htmlString) return '';
    const cleanTags = htmlString.replace(/<[^>]+>/g, ''); 
    const parser = new DOMParser();
    const doc = parser.parseFromString(cleanTags, 'text/html');
    return doc.body.textContent || '';
  };

  const truncateText = (htmlString, charLimit) => {
    const plainText = decodeHTML(htmlString);
    return plainText.length > charLimit ? plainText.substring(0, charLimit) + '...' : plainText;
  };

  const getPostImage = (post) => {
    if (post?.jetpack_featured_media_url) return post.jetpack_featured_media_url;

    // Try to find the BlogPosting image in AIOSEO schema graph
    const graph = post?.aioseo_head_json?.schema?.['@graph'];
    if (Array.isArray(graph)) {
      const blogPosting = graph.find(item => item['@type'] === 'BlogPosting');
      if (blogPosting?.image?.url) {
        return blogPosting.image.url;
      }
    }

    // Try to parse from content.rendered (regex match first image)
    const match = post?.content?.rendered?.match(/<img[^>]+src=["']([^"']+)["']/i);
    if (match && match[1]) {
      return match[1];
    }

    // Fallback to AIOSEO og:image
    if (post?.aioseo_head_json?.['og:image']) {
      return post.aioseo_head_json['og:image'];
    }

    return '';
  };
  
  return (
    <>

      <Helmet>
        <title>   
          Cardplot | Seamless Cross-Border Payments & Global Financial Connectivity Across Africa
        </title>
        <meta
          name="description"
          content="Cardplot is a fintech platform enabling secure cross-border payments, digital wallets, and global financial connectivity for Africans and businesses operating across international markets."/>
        <meta
          name="keywords"
          content="Cardplot, cross-border payments, send money Africa, virtual cards, virtual accounts, payment links, airtime and bill payments, African fintech, digital payments, Pan-African payments App, African money transfer, mobile money transfers in East Africa, mobile money transfers in West Africa, mobile money transfers in Central Africa, mobile money transfers in North Africa, mobile money transfers in South Africa, move money with african currencies, mobile money, African fiat currencies remittances, Cardplot Africa payments, Cardplot fintech, secure cross-border payments for Africans, best fintech platform for sending & receiving money in Africa, fintech, cross-border payments, 
                   African financial corridors, remittances, digital wallets, African payments, pan-African transfers, multi-currency digital wallet for African users, borderless payments for Africans, 
                   best fintech platform in Africa, best fintech platform for Africans, best fintech platform for businesses in Africa, best fintech platform for sending & receiving money in Africa, 
                   multi-currency digital wallet for African users, pan-african payment settlement system, pan-african payment gateway, pan-african payment processing, pan-african payment integration, pan-african payment solution, pan-african payment platform, pan-african payment system, pan-african payment technology, pan-african payment infrastructure, pan-african payment solution for businesses in Africa"/>

        {/* Open Graph tags */}
        <meta
          property="og:description"
          content="Securely send and receive money across African countries, manage virtual cards and accounts, and pay bills with Cardplot's all-in-one payment platform."/>
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cardplot.com/" />
        <meta property="og:image" content="https://cardplot.com/favicon.png" />

        {/* Twitter card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cardplot | Seamless Cross-Border Payments & Global Financial Connectivity Across Africa" />
        <meta
          name="twitter:description"
          content="Send, receive, and manage money across African countries with Cardplot’s secure payment platform."
        />
      </Helmet>
      <section className='hero__section'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6  mb-lg-0'>
              <div className='hero__content'>
                <h1 className='hero__title'>Accept Payments in every African currency</h1>
                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                  <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                    Get Started
                  </a>
                  <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                </div>
                <div className='d-flex gap-2' style={{ paddingTop: '60px' }}>
                  <Link to=''><img src={googleStore} className='img-fluid google__appstore' alt='link_img' /></Link>
                  <Link to=''><img src={appStore} className='img-fluid google__appstore' alt='link_img' /></Link>
                </div>
              </div>
            </div>
            <div className='col-md-6 mb-lg-0 d-none d-lg-block'>
              <div className='hero__image'>
                <img src={heroImg} className='img-fluid' alt='hero_image' />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='experience-section '>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='text-center'>
                <h2>Experience Simple, Seamless Cross-Border Payments</h2>
                <p>Discover a stress-free, fast, and secure way to transact across Africa.</p>
              </div>
              <div className='experience__section__video_card'>
                <div className='video__card fade-in-bottom'>
                  <div className='video-display'>
                    {/* <iframe width="560" height="315" className='custom-video' src="https://www.youtube.com/embed/Nj7zwJZ9bYI?si=3SabGtUT0Sb-7yI3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                    <video width="560" height="448" className="custom-video" autoPlay muted controls loop>
                      <source src={descriptionVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <div className='video__card__content'>
                      <Link to='' className='btn_how_it_work w-100 mt-3'>See how it works</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='our-advantage '>
        <div className='container'>
          <div className='row justify-content-center '>
            <div className='col-md-12'>
              <div className='our-advantage__header'>
                <h2 className='title'>Our Advantage</h2>
              </div>
            </div>
          </div>
          <div className='row justify-content-center ' style={{ paddingTop: '50px' }}>
            <div className='col-12 col-md-4 mb-5 mb-lg-0'>
              <div className='advantage__card'>
                <div className='advantage__icon'>
                  <img src={Icon5} className='img-fluid' alt='advantage icon' />
                </div>
                <div className='advantage__content fifth'>
                  <h3>Remittance and Money Transfers</h3>
                  <p>Fast and Reliable Money Transfers.</p>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4 mb-5 mb-lg-0'>
              <div className='advantage__card'>
                <div className='advantage__icon '>
                  <img src={Icon2} className='img-fluid' alt='advantage icon' />
                </div>
                <div className='advantage__content second'>
                  <h3>Seamless and Secure Transactions</h3>
                  <p>Your Security, Our Priority.</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-4 mb-5 mb-lg-0'>
              <div className='advantage__card'>
                <div className='advantage__icon'>
                  <img src={Icon3} className='img-fluid' alt='advantage icon' />
                </div>
                <div className='advantage__content third'>
                  <h3>Real-time Currency Conversion</h3>
                  <p>Instant  Conversions, No hide fees.</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-4 mb-5 mb-lg-0'>
              <div className='advantage__card'>
                <div className='advantage__icon'>
                  <img src={Icon4} className='img-fluid' alt='advantage icon' />
                </div>
                <div className='advantage__content fourth'>
                  <h3>International Payments & Virtual cards</h3>
                  <p>Seamless Transactions Beyond Borders.</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-4 mb-5 mb-lg-0'>
              <div className='advantage__card'>
                <div className='advantage__icon'>
                  <img src={Icon1} className='img-fluid' alt='advantage icon' />
                </div>
                <div className='advantage__content first'>
                  <h3>Enabling Pan-African & cross-border Trade</h3>
                  <p>Bringing Payments Closer Across Borders.</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-4 mb-5 mb-lg-0'>
              <div className='advantage__card'>
                <div className='advantage__icon'>
                  <img src={Icon6} className='img-fluid' alt='advantage icon' />
                </div>
                <div className='advantage__content six'>
                  <h3>Financial Management & Banking Access</h3>
                  <p>Smart Tools for Confident Financial Control.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='empowering__connections '>
        <div className='container'>
          <div className='row'>
            <div className='col-12 col-md-12'>
              <div className='text-center'>
                <h2 className='empowering__connections__title'>Empowering Connections, One Transaction at a Time.</h2>
                <p className='empowering__connections__subtitle'>Voices from across the continent, united by Cardplot.</p>
              </div>
            </div>
          </div>
          {/* <div className='empowering__connections__slider'>
          <div className='trustpilot__widget__container mt-5'>
            <TrustpilotWidget />
          </div>
          </div> */}
          <div className='text-center'>
            <Link to='#' className=' empowering__connections__slider__view__more__btn'>
              View More
            </Link>
          </div>
        </div>
      </section>

      <section className="send__money__section">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            600: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 1,
            },
          }}
          navigation={{
            prevEl: '.custom-prev',
            nextEl: '.custom-next'
          }}
          className="send__money__section__slider"
        >
          <div className="container">
            <SwiperSlide>
              <div className="send__money__section__slider__item">
                <div className="hero__image">
                  <img src={image3} alt="People using mobile payment" className="img-fluid send__money__section__slider__item__image" />
                </div>
                <div className="send__money__section__content">
                  <h1 className="send__money__section__title">
                    Send Money Across Over 20 African Countries
                  </h1>
                  <div className="flex mb-4">
                    {/* Add your country flag images here */}
                    <img src={nigeriaFlag} alt="Nigeria" className="flag-icon" />
                    <img src={senegalFlag} alt="Senegal" className="flag-icon" />
                    <img src={ghanaFlag} alt="Ghana" className="flag-icon" />
                    <img src={kenyaFlag} alt="Kenya" className="flag-icon" />
                    <img src={southAfricaFlag} alt="south africa" className="flag-icon" />
                    <img src={egyptFlag} alt="egypt" className="flag-icon" />
                    <img src={malawiFlag} alt="malawi" className="flag-icon" />
                    <img src={rwandaFlag} alt="rwanda" className="flag-icon" />
                  </div>
                  <p className="send__money__section__subtitle mb-0">
                    Sending and receiving payments across borders has never been easier
                  </p>
                  <div className="send__money__section__btns">
                    <a className='send__money__getstarted__btn' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                      Get Started
                    </a>
                    <Link to="/contact" className="send__money__contact__btn">
                      Contact us
                    </Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="send__money__section__slider__item">
                <div className="hero__image">
                  <img src={image4} alt="People using mobile payment" className="img-fluid send__money__section__slider__item__image" />
                </div>
                <div className="send__money__section__content">
                  <h1 className="send__money__section__title">
                    Send Money Across Over 20 African Countries
                  </h1>
                  <div className="flex mb-4">
                    {/* Add your country flag images here */}
                    <img src={nigeriaFlag} alt="Nigeria" className="flag-icon" />
                    <img src={senegalFlag} alt="Senegal" className="flag-icon" />
                    <img src={ghanaFlag} alt="Ghana" className="flag-icon" />
                    <img src={kenyaFlag} alt="Kenya" className="flag-icon" />
                    <img src={southAfricaFlag} alt="south africa" className="flag-icon" />
                    <img src={egyptFlag} alt="egypt" className="flag-icon" />
                    <img src={malawiFlag} alt="malawi" className="flag-icon" />
                    <img src={rwandaFlag} alt="rwanda" className="flag-icon" />
                  </div>
                  <p className="send__money__section__subtitle">
                    Sending and receiving payments across borders has never been easier
                  </p>
                  <div className="send__money__section__btns">
                    <a className='send__money__getstarted__btn' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                      Get Started
                    </a>
                    <Link to="/contact" className="send__money__contact__btn">
                      Contact us
                    </Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </div>
          {/* Add more slides as needed */}
        </Swiper>

        {/* Custom Navigation Buttons */}
        <div className="container relative">
          <button className="custom-prev absolute">
            <ArrowLeft className='' />
          </button>
          <button className="custom-next absolute ">
            <ArrowRight className='' />
          </button>
        </div>
      </section>

      <section className='find_your_account'>
        <div className='container'>
          <div className='row justify-content-center align-items-center'>
            <div className='col-12 col-md-6 order-1 order-md-1 mb-4 mb-lg-0'>
              <div className='find_your_account__image'>
                <img src={image1} className='img-fluid' alt='find your account' />
              </div>
            </div>
            <div className='col-12 col-md-6 order-2 order-md-2  mb-4 mb-lg-0'>
              <div className='text-center'>
                <h2 className='find_your_account__title'>You can send Nigerian Naira..</h2>
                <p className='find_your_account__subtitle'>Fund your account with naira. Choose the transfers tab and choose your destination country, the enter the amount you want the recipient to get in Ghanian Cedis .</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <img src={line} className='img-fluid position-relative line__inner' alt='img' width={550} />
            </div>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className='col-12 col-md-6 order-2 order-md-1  mb-4 mb-lg-0'>
              <div className='text-center'>
                <h2 className='find_your_account__title'>... and they receive Ghanian Cedi</h2>
                <p className='find_your_account__subtitle'>In a flash, we’ll convert your Nigerian Naira to Ghana Cedi and show you the total cost before you initiate the transaction.</p>
              </div>
            </div>
            <div className='col-12 col-md-6 order-1 order-md-2  mb-4 mb-lg-0'>
              <div className='find_your_account__image'>
                <img src={image2} className='img-fluid' alt='find your account' />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='convert__currency__section '>
        <div className='container'>
          
          <div className="row  justify-content-center align-items-center">
            <div className='col-12 col-md-6 my-3'>
              <div className="convert__currency_content">
                <h2 className="convert__currency__title">Convert your local currency to any other African currency!</h2>
                <p className="convert__currency__subtitle">Exchange your local currency in-app, then feel free to transact with it however you please with great exchange rates and low fees.</p>
              </div>
            </div>
            <div className='col-12 col-md-6 my-3'>
              <CurrencyConverter />
            </div>
          </div>
        </div>
      </section>

      <section className='news__section padding__tb__100'>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-12'>
              <h2 className='news__title text-center'>Blogs and Articles</h2>
              <p className='news__subtitle text-center'>
                Stay informed with relevant updates concerning your financial transactions across borders.
              </p>
            </div>
          </div>

          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
          >
            {posts?.slice(0, 6).map((post) => (
              <SwiperSlide key={post?.id}>
                <div className='new__card'>
                  <img
                    src={getPostImage(post)}
                    className='img-fluid news__image'
                    alt={decodeHTML(post?.title.rendered)}
                  />
                  <div className='news__content'>
                    <h5 className='news__content__title' dangerouslySetInnerHTML={{ __html: post?.title.rendered }} />
                    <p>{truncateText(post.excerpt.rendered, 100)}</p>
                    <div className='news__actions_btns mt-auto'>
                      <Link to={`https://blog.cardplot.com/${post?.slug}`} target="_blank" style={{ textDecoration: "underline !important"}} className='text-decoration-line' rel="noopener noreferrer">
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}

            {/* <SwiperSlide>
              <div className='new__card'>
                <img src={blog2} className='img-fluid news__image' alt='news' />
                <div className='news__content'>
                  <h5 className='news__content__title'>Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret</h5>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, iusto?</p>
                  <div className='news__link'>
                    <Link to='#'>Read More</Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='new__card'>
                <img src={blog3} className='img-fluid news__image' alt='news' />
                <div className='news__content'>
                  <h5 className='news__content__title'>Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret</h5>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, iusto?</p>
                  <div className='news__link'>
                    <Link to='#'>Read More</Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='new__card'>
                <img src={blog4} className='img-fluid news__image' alt='news' />
                <div className='news__content'>
                  <h5 className='news__content__title'>Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret</h5>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, iusto?</p>
                  <div className='news__link'>
                    <Link to='#'>Read More</Link>
                  </div>
                </div>
              </div>
            </SwiperSlide> */}
          </Swiper> 
        </div>
      </section>

      {/* <section className='partner__section padding__tb__100'>
      //   <div className='container'>
      //     <div className='row'>
      //       <div className='col-12'>
      //         <h2 className='partner__title'>Counted on by 1500+ Individuals & Businesses</h2>
      //       </div>
      //     </div>
      //     <Slider {...partners} className='partner__slider'>
      //       <div className='partner__card'>
      //         <img src={partner1} className='img-fluid' alt='partner' />
      //       </div>
      //       <div className='partner__card'>
      //         <img src={partner2} className='img-fluid' alt='partner' />
      //       </div>
      //       <div className='partner__card'>
      //         <img src={partner1} className='img-fluid' alt='partner' />
      //       </div>
      //       <div className='partner__card'>
      //         <img src={partner2} className='img-fluid' alt='partner' />
      //       </div>
      //       <div className='partner__card'>
      //         <img src={partner1} className='img-fluid' alt='partner' />
      //       </div>
      //       <div className='partner__card'>
      //         <img src={partner2} className='img-fluid' alt='partner' />
      //       </div>
      //     </Slider>
      //   </div>
      </section> */}

      <section className='empower_your_trade'>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="empower__title">
                <h2>Ready to simplify your payments?</h2>
                <p>Simplify Your Exchange, Empower Your Trade</p>
                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                  <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                    Get Started
                  </a>
                  <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-5 mb-lg-0 ">
              <div className="empower__img py-3">
                <img src={empowerImg} className='img-fluid' alt="empower" />
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default Home